import React from "react";
import { Link } from "react-router-dom";
import SectionHeader from "@/components/SectionHeader";
import { Hammer, ArrowRight } from "lucide-react";

export default function Projects() {
  return (
    <>
      <section className="bg-[#101827] text-white">
        <div className="ae-container pt-28 pb-16">
          <div className="ae-eyebrow mb-3">Our Projects</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold max-w-3xl">
            Selected mandates & case notes
          </h1>
          <p className="text-white/80 mt-5 max-w-3xl leading-relaxed">
            A curated showcase of our recent advisory, surveying and documentation engagements will be
            published here as we obtain client permissions.
          </p>
        </div>
      </section>

      <section className="ae-section">
        <div className="ae-container">
          <div className="ae-card p-10 text-center">
            <div className="w-14 h-14 rounded-full bg-[#F4F6F8] mx-auto flex items-center justify-center mb-5">
              <Hammer className="w-6 h-6 text-[#64748B]" />
            </div>
            <h3 className="font-display text-2xl font-semibold text-[#101827] mb-2">Project case studies coming soon</h3>
            <p className="text-[#64748B] max-w-xl mx-auto">We publish project details only after confirming client consent and verifying facts. In the meantime, our team is happy to discuss relevant engagements over a call.</p>
            <Link to="/contact" className="ae-btn-primary mt-6">Request a project discussion <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
